<template>
  <div v-loading='loading' class='gPageBorder'>

    <div v-show="this.editInfo.status === 3">
      <el-alert
        style='display:flex;display:-webkit-flex;margin: 0 0 24px 0;'
        :title="reason"
        type="error"
        show-icon>
      </el-alert>
    </div>


    <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="13.5%" class="gForm">

      <el-form-item :label="$t('app_ad') + $t('app_name')" prop="videoName">
        <el-input :placeholder="$t('app_input')" v-model="form.videoName"></el-input>
      </el-form-item>

      <el-form-item :label="$t('app_csvldate')" prop="time">
        <el-date-picker
          style='width:40%;margin-right:24px;'
          v-model="form.sTime"
          @change='sClick'
          type="date"
          :placeholder="stHolder"
          :picker-options="pickerOptions0">
        </el-date-picker>

        <el-date-picker
          style='width:40%;margin-right:24px;'
          v-model="form.eTime"
          @change='eClick'
          type="date"
          :placeholder="endHolder"
          :picker-options="pickerOptions0">
        
        </el-date-picker>
      </el-form-item>

      <!-- <el-form-item style='width:calc(100% + 20px);background:black;height:1px;background:#EAEEFA;margin-left:-10px;'>
      </el-form-item>

      <el-form-item  :label="$t('app_cstandt')" prop="version" v-show="fwVersionInputVisable" >
        <div style="">
          <el-input  v-model="input4" style=''>
            <el-select style='width:150px;' v-model="select" slot="prepend" >
              <el-option label="餐厅名" value="1"></el-option>
            </el-select>
            <template slot="append">{{$t('app_sc')}}</template>
          </el-input>

          <el-row v-for='item in times'>
            <el-col :span='23'>
            <el-input  v-model="item.vl" style=''>
                <el-select style='width:150px;' v-model="select" slot="prepend" >
                  <el-option label="餐厅名" value="1"></el-option>
                </el-select>
                <template slot="append">{{$t('app_sc')}}</template>
              </el-input>
            </el-col>
            <el-col :span='1'>
              &nbsp;&nbsp;<i style='color:red;' class="el-icon-circle-close" @click='rowDel(item)'></i>
            </el-col>
          </el-row>
          <el-button @click='addInput' style='width:100%;text-align:left;border:dashed 1px rgba(207,214,220,1);color:rgba(180,188,204,1)'>+{{$t('app_additv')}}</el-button>
        </div>
      </el-form-item> 


      <el-form-item style='width:calc(100% + 20px);background:black;height:1px;background:#EAEEFA;margin-left:-10px;'>
      </el-form-item> -->

    

      <el-form-item :label="$t('app_vdofile')" v-show="true" prop='url'>

        <el-upload
          class="upload-demo aeMg"
          :data='uData'
          drag
          name='fileUpload'
          :file-list="fileList"
          :on-success="fileUploadSuccess"
          :before-upload="fileBeforeUpload"
          :action="$videoUrl">


          <span>
            <i v-if='ulinfo.index === 0' :class="ulinfo.icons[ulinfo.index]"></i>
            
            <div v-else style='margin-top:12px;color:#48576A;'>
              
              <i :style=tipColor :class="ulinfo.icons[ulinfo.index]"></i>
              <el-col>
                <el-row style='margin-top:-8px;'>
                  <div></div>
                  <div style='height:26px;'>{{$t('app_filename')}}:&nbsp;{{form.fileName}}</div>
                  <div style='height:26px;'>{{$t('app_vdodur')}}:&nbsp;{{form.duration}}</div>
                  <div style='height:26px;'>{{$t('app_fileSize')}}:&nbsp;{{form.size}}</div>
                  <div style='height:26px;'>{{$t('app_vsize')}}:&nbsp;{{form.dimension}}</div>
                  <div>
                    <label style='margin-top:6px;color:#B2BBC5;font-size:12px;'>{{$t('app_clreulvdo')}}</label>
                  </div>
                </el-row>
              </el-col>  
            </div>
            <div v-show='ulinfo.index === 0' class="el-upload__text">{{ulinfo.tip}}</div>
          </span>

        </el-upload>

        <!-- <el-upload
          class="upload-demo aeMg"
          :data='uData'
          drag
          name='fileUpload'
          :file-list="fileList"
          :on-success="fileUploadSuccess"
          :before-upload="fileBeforeUpload"
          :action="fileUploadUrl">


          <span>
            <i v-if='ulinfo.index === 0' :class="ulinfo.icons[ulinfo.index]"></i>
            <div v-else style='margin-top:50px;'><i :style=tipColor :class="ulinfo.icons[ulinfo.index]"></i></div>
            <div class="el-upload__text">{{ulinfo.tip}}</div>
          </span>

        </el-upload> -->

      </el-form-item>


      <el-form-item>
        <el-button type="" @click="$router.go(-1)">{{$t('app_cancel')}}</el-button>

        <el-button v-if='isUpload' type="primary" @click="onSubmit">{{$t('app_addvdoad')}}</el-button>
        <el-button v-else type="primary" @click="onSubmit">{{$t('app_edvdoad')}}</el-button>
      </el-form-item>

    </el-form>


  </div>

</template>

<style>
</style>

<script>
 
  var tCheck = (rule, value, callback) => {
      if (!window.self.form.sTime || !window.self.form.eTime) {

        callback(new Error(window.self.$t('app_select') + window.self.$t('app_tofvalis')));
      } else {
        callback()
      }
  }
  import mm from 'moment'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
    data (){
      var that = this
      return{
        tipColor: {color: '#13CE66'},
        ulinfo: {
          tip: this.$t('app_ulNormalSt'),
          index: 0,
          icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
        },
        mechanismData: '',
        uData: '',
        editInfo: '',
        mechs: [],
        loading: 0,
        isUpload: true,
        fileList: [],
        times: [],
        form: {
          videoName: '',
          url: '',
          duration: '',
          size: '',
          hash: '',
          sTime: '',
          eTime: '',
          dimension: ''
        },
        rules:{
          'videoName':[{
            required: true,
                  message: this.$t('lin_global.notBlankName')
          }],
          'time':[{
            required: true,
                  message: this.$t('app_sllimit'),
                  validator:tCheck
          }],
          'type':[{
            required: true,
                  message: this.$t('lin_global.qxzlx')
          }],
          'mechanism':[{
            required: true,
                  message: this.$t('app_selectChannel')
          }],
          'url':[{
            required: true,
                  message: this.$t('app_plsUpl')
          }]
        },
        areaList:[],
        fwVersionInputVisable: true
      }
    },
    mounted(){
      var isEdit = this.$route.path === '/video-list/edit-video'
      this.isUpload = !isEdit
      window.self = this
      var mVl = ''
      if (!this.isUpload) {
        var obj = this.$getWObj().editVideo.data
        if (obj) {
          this.editInfo = obj
          this.fillData()
        }
        mVl = obj.mechanismId
      }
      this.mechanismData = {
        value: mVl,
        placeholder: this.$t('lin_global.place_areaid'),
        optValue: true,
        callback (value) {
          this.form.mechanism = value
        }
      }
    },
    computed: {
      reason () {
        if (!this.editInfo) {
          return ''
        }
        var rs = this.editInfo.refuseReason
        return rs? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason')  + ':' +  this.$t('app_noInput')
      },
      stHolder () {
        var tip = this.$t('app_slsttime')
        if (this.form.stTime) tip = ''
        return tip
      },
      endHolder () {
        var tip = this.$t('app_slendtime')
        if (this.form.endTime) tip = ''
        return tip
      },
      fileUploadUrl () {
        // return this.$fileUploadUrl
        return this.$urls.fileUrl
      },
      typeHolder () {
        if (this.isUpload) {
          return this.$t('app_select')
        } else {
          return ''
        }

      }
    },
    methods:{
      sClick (vl) {
        if (this.form.eTime) {
          this.timeCp(0)
        }
      },
      eClick (vl) {
        if (this.form.sTime) {
          this.timeCp(1)
        }
      },
      timeCp (w) {
        var ill = mm(this.form.eTime).isBefore(this.form.sTime)
        if (ill && w === 0) {
          this.$message.error(this.$t('app_sttcanlateendtime'))
          this.form.sTime = ''
        } else if (ill && w === 1) {
          this.$message.error(this.$t('app_etcanelsttime'))
          this.form.eTime = ''
        }
      },
      rowDel (item) {
        var findex
        this.times.forEach((vl,index) => {
          if (vl.id === item.id) {
            findex = index
          }
        })
        this.times.splice(findex, 1)
      },
      addInput () {
        var index = this.times.length === 0 ? 0 : this.times.length
        this.times.push({id: index, vl: ''})
      },
      fillData () {
        this.ulinfo.index = 1
        var fileName = this.editInfo.url.split('/')
        fileName = fileName.length > 0 ? fileName[fileName.length - 1] : ''
      
        this.form.videoName = this.editInfo.videoname
        this.form.url = this.editInfo.url
        this.form.sTime = this.editInfo.sTime
        this.form.eTime = this.editInfo.eTime
        this.form.duration = this.editInfo.duration
        this.form.size = this.editInfo.size
        this.form.hash = this.editInfo.hash
        this.form.dimension = this.editInfo.dimension
        this.form.fileName = fileName
        this.fileList = [{name: fileName}]
        var _this = this
      },
      hBlur (name) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
      fileUploadSuccess (res, file) {
        window[this.$route.path] = ''
        console.log('file', res)
        this.ulinfo.tip = res.message
        if (res.status === 200) {
          this.form.url = res.url
          this.form.dimension = res.dimension
          this.form.duration = res.duration
          this.form.hash = res.hash
          this.form.size = res.size
          this.form.fileName = file.name
          // this.form.packageName = res.packageName
          // this.fileSize = res.appSize
          this.fileList = [{name: file.name}]
          this.hBlur()
          
          this.ulinfo.index = 1
          this.tipColor = {color: '#13CE66'}
       
        } else {
          this.ulinfo.index = 2
          this.tipColor = {color: '#FF4949'}
          if (this.config.type !== 1) {
            this.fileList = []
          } else {
            this.fileList = [{name: file.name}]
          }
          this.$message.error(this.$t('app_onlyApk'))
        }
      },
      fileBeforeUpload (file) {
        console.log(file)
        window[this.$route.path] = 1
        return 1
        /* if (file) {
          var ar = file.name.split('.')
          var type = ar[ar.length - 1]
          if (type === 'apk') {
            var limit = 500000 // k单位
            if (file.size / 1000 > limit) {
              this.$message.error(this.$t('app_fileOver') + '500M')
              return false
            }
            window[this.$route.path] = 1
            return true
          } else {
            this.$message.error(this.$t('app_onlyApk'))
            return false
          }
        } else {
          this.$message.error(this.$t('app_onlyApk'))
          return false
        } */
      },
      onSubmit:function(){
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.loading = 1
            var isUpload = !this.editInfo
            var st = mm(this.form.sTime).format('YYYY-MM-DD')
            var et = mm(this.form.eTime).format('YYYY-MM-DD')
            var mid = localStorage.mechanismId
            
            //return

            if (isUpload) {
              // console.log(this.form.url)
              this.$addVideo(this.form.videoName, this.form.url, this.form.duration, mid, this.form.size, this.form.hash, st, et, this.form.dimension, (res) => {
                // console.log(res)
                this.loading = 0
                if (res.status === 200) {
                  this.$message.success(res.message)
                  this.$router.go(-1)
                } else {
                  this.$message(res.message)
                }
              }, () => {
                this.loading = 0
                this.$message(this.$t('app_rqsError'))
              })
            } else {
              this.loading = 0
              this.$editVideo(this.editInfo.videoid, this.form.videoName, this.form.url, this.form.duration, this.form.size, this.form.hash, this.form.sTime, this.form.eTime, this.form.dimension, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.$router.go(-1)
                  this.$message.success(res.message)
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          } else {
            return false
          }
        })
      },
      onCancel:function(){
        this.$router.go(-1);
      },
      selectTypeChange: function (value) {
          if (value === 'KSP' || value === 'KOS') {
              this.fwVersionInputVisable = true
          } else {
            this.form.version = ''
            this.fwVersionInputVisable = false
          }
          console.log('select value: ' + value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?1262891f